import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { useRemoveAiThread } from '../../../../../api/denaliAssistant'
import { decipherError } from '../../../../../utils/decipherError'
import SydModalActions from '../../../../../components/commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../components/commonDesign/Button'

const useSubmitter = (form, threadId, onComplete) => {
  const { handleSubmit, clearErrors } = form
  const { mutateAsync: removeThread, isLoading } = useRemoveAiThread()
  const onSubmit = useCallback(async () => {
    const command = {
      threadId
    }

    try {
      form?.clearErrors?.()
      const result = await removeThread(command)
      onComplete(result)
    } catch (err) {
      form.setError('root', {
        type: 'custom',
        message: decipherError(err) || 'Something unexpected happened while deleting the thread.'
      })
    }
  }, [form, threadId, onComplete, removeThread])

  const submitter = useCallback(async (e) => {
    const onValid = async (form) => {
      await onSubmit(form)
    }
    const onInvalid = (errors) => {
      console.error(errors)
    }
    clearErrors()
    const handler = handleSubmit(onValid, onInvalid)
    await handler(e)
  }, [handleSubmit, clearErrors, onSubmit])

  return {
    submitter,
    processing: isLoading
  }
}

function DeleteThreadForm ({ thread, onCancel, onComplete }) {
  const form = useForm({
    mode: 'onChange',
    defaultValues: {}
  })
  const { submitter, processing } = useSubmitter(form, thread?.threadId, onComplete)

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          Are you sure you want to delete this thread?
        </Grid>

        {/* Actions */}
        <Grid item xs={12}>
          <SydModalActions>
            {/* {error && <div className='__error'>{error}</div>} */}
            <SydButton
              disabled={processing}
              variant='ghost'
              size='md'
              onClick={onCancel}
            >
              Cancel
            </SydButton>
            <SydButton
              processing={processing}
              variant='primary'
              priority='warning'
              icon='delete'
              size='md'
              onClick={submitter}
            >
              Delete Thread
            </SydButton>
          </SydModalActions>
        </Grid>
      </Grid>
    </div>
  )
}

DeleteThreadForm.propTypes = {
  thread: PropTypes.shape({
    threadId: PropTypes.string.isRequired
  }).isRequired,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default DeleteThreadForm
